import React, { useEffect } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Card } from 'react-bootstrap';
import { getDeviceSensors, subscribeEgDeviceKPI } from '../../../actions/farm-monitor';
import CardItem from './DeviceCard';
import { searchWord } from '../../../helpers/common';

const DeviceCards = (props) => {
    const { selectedPlanTypeId, isRequesting, deviceById, searchText } = props;

    useEffect(() => {
        const egListWithDeviceId = Object.keys(deviceById).map(id => ({ equipmentGroupId: deviceById[id].equipmentGroupId, deviceId: id }));
        if (egListWithDeviceId.length !== 0) {
            props.actions.getDeviceSensors(egListWithDeviceId);
            props.actions.subscribeEgDeviceKPI(egListWithDeviceId);
        }
    }, [deviceById]);

    const filteredDeviceListIds = Object.keys(deviceById)
        .filter(deviceId => (deviceById[deviceId].planTypeId === selectedPlanTypeId || deviceById[deviceId].planTypeId === 0));

    const filteredSearchList = filteredDeviceListIds.filter(deviceId => searchWord(deviceById[deviceId].deviceName, searchText));

    return <Card.Body className="q-app-body">
        {(isRequesting || filteredSearchList.length === 0)
            ? <div className="no-records-found">{isRequesting ? "Loading..." : "No Devices Found"}</div>
            : filteredDeviceListIds.map(id => <CardItem key={id} id={id} className={`${filteredSearchList.indexOf(id) < 0 && "hide"}`} />)}
    </Card.Body>
}

const mapStateToProps = state => {
    return ({
        deviceById: state.farmMonitor.deviceById.payload,
        isRequesting: state.farmMonitor.deviceById.isRequesting,
        selectedPlanTypeId: state.farmMonitor.selectedPlanTypeId
    });
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        getDeviceSensors, subscribeEgDeviceKPI
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DeviceCards);